import React from 'react';
import { Button } from '@mui/material';
import {
  HeroSubtitle,
  HeroTitle,
  HeroWrapper,
  HeroButtonContainer
} from './styled';

function Hero(): JSX.Element {
  return (
    <HeroWrapper>
      <HeroTitle>Find Your Clarity</HeroTitle>
      <HeroSubtitle>Get Guidance on Your Future</HeroSubtitle>
      <HeroButtonContainer>
        <Button
          className="hero-button"
          variant="primary"
          href="/psychic-readings/195"
          sx={{
            fontSize: '14px',
            padding: '11px 24px 9px'
          }}>
          Find an Advisor
        </Button>
      </HeroButtonContainer>
    </HeroWrapper>
  );
}

export default Hero;
